import React from 'react';
import { FootprintsIcon, PersonStandingIcon, HandIcon, WavesIcon } from 'lucide-react';
import { mobilityAreas, harvestImage } from '../../data/presellContent';
const icons = {
  knees: FootprintsIcon,
  hips: PersonStandingIcon,
  hands: HandIcon,
  mobility: WavesIcon
} as const;
export function EverydayMobility() {
  return <section id="mobility" className="w-full bg-[#F7F9F8]" data-id="element-15" data-mp="utv738rkyb7">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 md:py-20" data-id="element-16" data-mp="3sz66cf6vefec">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-17" data-mp="3nztaj4y0txzm">
          <figure data-id="element-18" data-mp="3o1w8cb5f0vew">
            <img src={harvestImage} alt="An older Japanese woman gathering a harvest in a rural field" className="w-full h-[240px] sm:h-[300px] md:h-[360px] object-cover rounded-2xl" loading="lazy" data-id="element-19" data-mp="3j0qf8c7uf64u" />
            <figcaption className="mt-3 text-sm text-[#8A9A8F]" data-id="element-20" data-mp="1h8kcjbow9j2s">
              Bending, crouching and gripping — ordinary movements, still part of
              daily life here.
            </figcaption>
          </figure>

          <h2 className="text-2xl md:text-4xl font-bold text-[#22322C] leading-snug" data-id="element-21" data-mp="2yv08ef075cjc">
            When Joint Lubrication Starts To Decline, Everyday Movement Can Feel
            Different
          </h2>
        </div>

        <ul className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-22" data-mp="2ttavetteyosm">
          {mobilityAreas.map(({
          id,
          area,
          description
        }) => {
          const Icon = icons[id];
          return <li key={id} className="bg-white rounded-2xl border border-[#E5E9E7] p-6 flex flex-col" data-id="element-23" data-mp="3mihupv0oziex">
                <span className="w-11 h-11 rounded-full bg-[#EAF1EE] flex items-center justify-center" data-id="element-24" data-mp="37r9ay2jh0r9p">
                  <Icon className="w-5 h-5 text-[#3F8C86]" aria-hidden="true" data-id="element-25" data-mp="3cqc6mwdk9l50" />
                </span>
                <h3 className="mt-5 text-lg font-semibold text-[#22322C]" data-id="element-26" data-mp="4asfc2wgacsl">
                  {area}
                </h3>
                <p className="mt-2 text-[#5A6D60] leading-relaxed" data-id="element-27" data-mp="iz25hj9wbork">
                  {description}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}